import styled from 'styled-components';

export const TabsWrapper = styled.div`
    margin-top: -16px;
`;

export const GroupWrapper = styled.div`
    padding: 16px 0;
`;

export const NewTaskButton = styled.div`
    margin-bottom: 16px;
    margin-top: 8px;
    display: flex;
    align-items: center;
    cursor: pointer;
`;

export const Label = styled.div`
    display: inline-block;
    margin-left: 18px;
    font-size: 20px;
`;
